import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "terminal-template-page",
  style: {"padding-top":"12px"}
}
const _hoisted_2 = { style: {"padding":"0 0 12px"} }

import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  XrkTable,
  XrkTableRef,
  XrkTableProps,
  useTableColumn,
  useInputColumn,
  useSelectColumn,
  BaseButton,
  XrkMessage,
  XrkMessageBox,
  useCreateModal
} from 'xrk-components';

import { formatter, file } from '@/utils';
import { download } from 'xrk-tools';
import {
  listTerminalTemplate,
  delOrEnabledTemplate
} from '../data-source/apis';
import type { TerminalTemplateRow } from '../data-source/types';
import {
  TERMINAL_TEMPLATE_STATUS,
  TerminalTemplateStatus,
  DelOrEnabledType
} from '../constants';
import TerminalTemplateDialog from '../components/terminal-template-dialog.vue';
import { ArrowLeft } from '@element-plus/icons-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-template-list',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const { parentPath } = route.meta;

const xrkTableRef = ref<XrkTableRef>(null);

const goBack = () => {
  router.push({ path: parentPath as string, query: { tab: route.query.tab } });
};

const getListAjax = async params => listTerminalTemplate(params);

const onOpenDialog = (id?: number) => {
  useCreateModal(TerminalTemplateDialog, {
    id,
    onSuccess: () => xrkTableRef.value?.initCurrentList()
  });
};

const onToggle = async (row: TerminalTemplateRow) => {
  const nextEnabled = row.enabled === TerminalTemplateStatus.DISABLED;
  const verb = nextEnabled ? '启用' : '停用';

  if (nextEnabled) {
    const params = {
      id: row.id,
      type: DelOrEnabledType.TOGGLE,
      enabled: TerminalTemplateStatus.ENABLED,
      check: 0
    };
    const { data } = await delOrEnabledTemplate({ ...params, check: 1 });
    if (+data === 7779) {
      await XrkMessageBox.confirm(
        '当前合同模板类型的甲乙方存在启用的模板，是否继续启用，启用后原合同模板将会停用',
        '提示',
        { confirmButtonText: '确定启用', cancelButtonText: '取消' }
      );
      await delOrEnabledTemplate(params);
      XrkMessage.success('已启用');
      xrkTableRef.value?.initCurrentList();
      return;
    }
    XrkMessage.success('已启用');
    xrkTableRef.value?.initCurrentList();
    return;
  }

  await XrkMessageBox.confirm(
    `是否${verb}模版「${row.contractTemplateName}」？`,
    '提示',
    { confirmButtonText: '确定', cancelButtonText: '取消' }
  );
  await delOrEnabledTemplate({
    id: row.id,
    type: DelOrEnabledType.TOGGLE,
    enabled: TerminalTemplateStatus.DISABLED
  });
  XrkMessage.success('操作成功');
  xrkTableRef.value?.initCurrentList();
};

const onDelete = async (row: TerminalTemplateRow) => {
  await XrkMessageBox.confirm(
    `是否删除模版「${row.contractTemplateName}」？`,
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }
  );
  await delOrEnabledTemplate({ id: row.id, type: DelOrEnabledType.DELETE });
  XrkMessage.success('删除成功');
  xrkTableRef.value?.initCurrentList();
};

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchColumns: [
    useInputColumn({
      prop: 'contractTemplateName',
      label: '模版名称',
      config: { placeholder: '请输入模版名称', maxlength: 50 }
    }),
    useSelectColumn({
      prop: 'enabled',
      label: '状态',
      config: {
        placeholder: '请选择',
        clearable: true,
        options: TERMINAL_TEMPLATE_STATUS
      }
    })
  ],
  otherComponents: [
    {
      render() {
        return (
          <>
            <BaseButton type="primary2" click={() => onOpenDialog()}>
              新建模版
            </BaseButton>
          </>
        );
      }
    }
  ]
});

const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({ type: 'index', label: '序号', width: '80px' }),
    useTableColumn({
      label: '模版名称',
      prop: 'contractTemplateName',
      minWidth: 200
    }),
    useTableColumn({
      label: '合同有效期',
      prop: 'validityEnd',
      width: 200,
      render: ({ row }) => {
        if (row.validityStart === '长期') return '长期有效';
        if (!row.validityStart || !row.validityEnd) return '-';
        return (
          <>
            <span>{formatter.date(row.validityStart, 'YYYY-MM-DD')}</span>
            <span> - </span>
            <span>{formatter.date(row.validityEnd, 'YYYY-MM-DD')}</span>
          </>
        );
      }
    }),
    useTableColumn({
      label: '模版文件',
      prop: 'urlFileName',
      minWidth: 200,
      render: ({ row }) =>
        row.contractTemplateUrl ? (
          <BaseButton
            link
            type="primary2"
            click={() => file.preview(row.contractTemplateUrl)}
          >
            {row.urlFileName || '查看模版'}
          </BaseButton>
        ) : (
          '-'
        )
    }),
    useTableColumn({
      label: '状态',
      prop: 'enabled',
      width: 100,
      formatter: ({ cellValue }) =>
        TERMINAL_TEMPLATE_STATUS.find(s => s.value === cellValue)?.label || '-'
    }),
    useTableColumn({
      label: '创建时间',
      prop: 'createAt',
      width: 180,
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '备注',
      prop: 'remarks',
      minWidth: 160,
      formatter: ({ cellValue }) => cellValue || '-'
    }),
    useTableColumn({
      label: '操作',
      prop: 'handle',
      fixed: 'right',
      width: 280,
      render: ({ row }) => (
        <>
          <BaseButton type="text" click={() => onOpenDialog(row.id)}>
            编辑
          </BaseButton>
          <BaseButton
            type="text"
            click={() => download.downloadFile(row.contractTemplateUrl)}
            disabled={!row.contractTemplateUrl}
          >
            下载
          </BaseButton>
          <BaseButton type="text" click={() => onToggle(row)}>
            {row.enabled === TerminalTemplateStatus.ENABLED ? '停用' : '启用'}
          </BaseButton>
          <BaseButton type="text" click={() => onDelete(row)}>
            删除
          </BaseButton>
        </>
      )
    })
  ]
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BaseButton), {
        link: "",
        icon: _unref(ArrowLeft),
        onClick: goBack
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回")
        ]),
        _: 1
      }, 8, ["icon"])
    ]),
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})